import { render, staticRenderFns } from "./Ec2MachineCard.vue?vue&type=template&id=0ba36ae8&scoped=true"
import script from "./Ec2MachineCard.vue?vue&type=script&lang=js"
export * from "./Ec2MachineCard.vue?vue&type=script&lang=js"
import style0 from "./Ec2MachineCard.vue?vue&type=style&index=0&id=0ba36ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba36ae8",
  null
  
)

export default component.exports